import React from 'react';

const ChefHatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        {/* Hat Crown / Cloud Body */}
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7 17v-4c-4 0-4-6 1-6c0-5 8-5 8 0c5 0 5 6 1 6v4H7z"
        />
        {/* Bottom Brim / Band */}
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 17h12v3H6z"
        />
        {/* Vertical Pleats / Folds */}
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 17v-4m3 4v-4m3 4v-4"
        />
    </svg>
);

export default ChefHatIcon;
